import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  theme => ({
    container: {
      maxWidth: "100%",
      marginBottom: "17rem"
    },
    pageHeader: {
      marginBottom: "1.2rem",
      "& > :first-child": {
        // visibility: props => (props.fullScreen ? "hidden" : "visible"),
        margin: 0
        // marginBottom: props => (props.fullScreen ? "0.4rem" : "1.2rem")
      },
      "& > :nth-child(2)": {
        alignSelf: "flex-end"
      }
    },
    inlineBlock: {
      display: "inline-block",
      color: theme.palette.grey[900]
    },
    titleMain: {
      color: theme.palette.info.main
    },
    iconModal: {
      position: "absolute",
      left: "45%",
      top: "20px"
    },
    boxContainer: {
      paddingBottom: "20rem"
    },
    tab: {
      padding: "10px 0",
      textAlign: "center"
    },
    tabBox: {
      "&>span:last-child": {
        borderRadius: "0 12px 0 0"
      },
      "&>span:first-child": {
        borderRadius: "12px 0 0 0"
      }
    },
    titleDelete: {
      color: theme.palette.error.light
    },
    snackHeadTitle: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      columnGap: "1.2rem"
    },
    backDrop: {
      zIndex: 1399
    },
    boxInfo: {
      marginTop: "3rem"
    },
    SoNo: {
      color: theme.palette.info.main
    },
    alignRight: {
      textAlign: "right"
    },
    flex: {
      display: "flex",
      alignItems: "center"
    },
    statusIcon: {
      width: 8,
      height: 8,
      marginRight: 8,
      borderRadius: "50%"
    },
    textRed: {
      color: theme.palette.error.light
    },
    statusLabel: {
      "& span": {
        width: 8,
        height: 8,
        marginRight: 8,
        borderRadius: "50%"
      }
    },
    smallCircle: {
      width: "20px",
      height: "20px",
      borderRadius: "50%",
      backgroundColor: "#000"
    },
    cashSaleStatusError: {
      color: theme.palette.error.light
    }
  }),
  { name: "NotRefContractComponent" }
);

export default useStyles;
